import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePdlSearchV2 from './usePdlSearchV2'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import useMeterSearchStyles from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchStyles'

const PdlSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { openButtonKind, openButtonOverrides } = useMeterSearchStyles()
  const { updatePdlConfigData } = usePdlSearchV2()

  const handleOpenModal = () => {
    updatePdlConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <SDButton
      overrides={openButtonOverrides}
      kind={openButtonKind}
      size={SIZE.compact}
      id='pdl-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pdl_module.search_text_v2')}
    </SDButton>
  )
}

export default PdlSearchButton
